import React, { Dispatch, SetStateAction } from 'react'
import { FileSelector } from 'src/components/Reusable/Forms/FileSelector/FileSelector'
import { AddReportFormData } from './AddReportForm'

type ReportFileSelectorProps = {
  formData: AddReportFormData
  setFormData: Dispatch<SetStateAction<AddReportFormData>>
}

export const ReportFileSelector = ({
  formData,
  setFormData,
}: ReportFileSelectorProps): JSX.Element => {
  if (formData.body) {
    return <></>
  }

  const onChange = (files: File[]) => {
    const file = files[0]

    if (file) {
      setFormData((state) => {
        const newState: AddReportFormData = {
          ...state,
          mime: file.type,
          body: file,
        }
        return newState
      })
    }
  }

  return (
    <FileSelector
      onChange={onChange}
      isLoading={false}
      isValid={false}
      errorMessage={''}
    />
  )
}
